var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { corPrimaria, corPrimariaSuave } from '../tema';
export var IconTileStyled = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  font-size: 1.35rem;\n  color: ", ";\n  background: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  font-size: 1.35rem;\n  color: ", ";\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'pdf' ? '#d93025' : corPrimaria(theme));
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'pdf' ? '#fdecea' : corPrimariaSuave(theme));
});
var templateObject_1;
